let baseUrl = "";
let baseUrlGz = "";
let baseUrlAccount = "";
let audioUrl = "";
let gzUrl = {
  speaking: "/gaozhen/testMic.html",
  examList: " /gaozhen/user-examlist.html",
  reportList: " /gaozhen/user-report-list.html",
  grammarReport: "/gaozhen/user-report-grammar.html",
  writingReport: "/gaozhen/user-report-writing.html",
  listenReport: "/gaozhen/user-report-listen.html",
  report: "/gaozhen/user-report-new.html",
  speakingReport: "/gaozhen/user-report-oral.html",
  oralReport: "/gaozhen/user-report-oral.html",
  trialListenReport: "/gaozhen/trial-report-listen.html?skill=S1",
  trialReadReport: "/gaozhen/trial-report-read.html?skill=S2",
  trialGrammarReport: "/gaozhen/trial-report-grammar.html?skill=S3",
  trialWritingReport: "/gaozhen/trial-report-writing.html?skill=S4",
  trialOralReport: "/gaozhen/trial-report-oral.html",
  //第三方
  TgrammarReport: "/gaozhen/third-user-report-grammar.html",
  TwritingReport: "/gaozhen/third-user-report-writing.html",
  TlistenReport: "/gaozhen/third-user-report-listen.html",
  Treport: "/gaozhen/third-user-report-new.html",
  TspeakingReport: "/gaozhen/third-user-report-oral.html",
  ToralReport: "/gaozhen/third-user-report-oral.html",
};
let baseLinkName = "gz";
let loginUrl = "/#/login";
let roleCon = 0;
let role = 0;
//cookie清空
function clearCookie() {
/*eslint-disable*/ 
  var keys = document.cookie.match(/[^ =;]+(?=\=)/g);
  if (keys) {
    for (var i = keys.length; i >= 0; i--) {
      document.cookie =
        keys[i] + "=0;Path=/gz/student;expires=" + new Date(0).toUTCString();
      document.cookie =
        keys[i] + "=0;Path=/gz/student/;expires=" + new Date(0).toUTCString();
    }
  }
}

//无登录信息
if (!window.localStorage.getItem("fltrp-home-token")) {
  // window.location.href = "/";
} else if(window.localStorage.getItem("fltrp-home-userAppRoles")){
  clearCookie();
  JSON.parse(window.localStorage.getItem("fltrp-home-userAppRoles")).some(
    (element) => {
      if (element.appCode == "gaozhen") {
        role = Number(element.roleCode);
        return true;
      }
    }
  );
  let Days = 30;
  let exp = new Date();
  //登录信息
  exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000);
  //用户id
  document.cookie =
    "user-id=" +
    encodeURI(window.localStorage.getItem("fltrp-home-loginId")) +
    ";expires=" +
    exp.toGMTString();
  //token
  document.cookie =
    "token=" +
    encodeURI(window.localStorage.getItem("fltrp-home-token")) +
    ";expires=" +
    exp.toGMTString();
  // 管理员：2 • 机构管理员：3 • 教师：5 • 学生：7
  switch (role) {
    case 1:
      roleCon = 7;
      break;
    case 2:
      roleCon = 5;
      break;
    case 3:
      roleCon = 3;
      break;
    case 4:
      roleCon = 2;
      break;
  }
  document.cookie =
    "user-role=" + encodeURI(roleCon) + ";expires=" + exp.toGMTString();
  //userID
  document.cookie =
    "user-idcon=" +
    encodeURI(window.localStorage.getItem("fltrp-home-userId")) +
    ";expires=" +
    exp.toGMTString();
}
let VUE_APP_TITLE=process.env.VUE_APP_TITLE
// VUE_APP_TITLE="production"
switch (VUE_APP_TITLE) {
  case "development":
    baseUrl = "https://prelearn.fltrp.com/jzapi/";
    baseUrlGz = "https://prelearn.fltrp.com/gz/";
    baseUrlAccount = "https://prelearn.fltrp.com/accountapi/";
    audioUrl = "https://cdn-oss-unilearn.fltrp.com/ib/";
    break;
  case "test":
    baseUrl = "https://prelearn.fltrp.com/jzapi/";
    baseUrlGz = "https://prelearn.fltrp.com/gz/";
    baseUrlAccount = "https://prelearn.fltrp.com/accountapi/";
    audioUrl = "https://cdn-oss-unilearn.fltrp.com/ib/";
    break;
  case "Ptest":
    baseUrl = "https://47.102.144.55/jzapi/";
    baseUrlGz = "https://47.102.144.55/gz/";
    baseUrlAccount = "https://47.102.144.55/accountapi/";
    audioUrl = "https://cdn-oss-unilearn.fltrp.com/ib/";
    break;
  case "production":
    baseUrl = "https://unilearn.fltrp.com/jzapi/";
    baseUrlGz = "https://unilearn.fltrp.com/gz/";
    baseUrlAccount = "https://unilearn.fltrp.com/accountapi/";
    audioUrl = "https://cdn-oss-unilearn.fltrp.com/ib/";
    break;
}
export {
  baseUrl,
  baseUrlGz,
  baseLinkName,
  audioUrl,
  gzUrl,
  loginUrl,
  baseUrlAccount,
};
